import React from 'react';

const ThemeToggle = ({ isDarkMode, onToggle }) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      minWidth: '140px',
      justifyContent: 'space-between',
      flexShrink: 0,
      padding: '4px'
    }}>
      <span style={{
        color: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : '#1a1a1a',
        fontSize: '14px'
      }}>Light</span>
      
      <div
        onClick={onToggle}
        style={{
          width: '44px',
          height: '24px',
          background: isDarkMode ? '#1a1a1a' : '#e1e4e8',
          borderRadius: '12px',
          cursor: 'pointer',
          position: 'relative',
          transition: 'background-color 0.2s ease',
          border: `1px solid ${isDarkMode ? '#333' : '#d0d7de'}`,
          display: 'flex',
          alignItems: 'center',
          padding: '0 2px'
        }}
      >
        <div style={{
          width: '18px',
          height: '18px',
          background: '#fff',
          borderRadius: '50%',
          position: 'absolute',
          left: isDarkMode ? '22px' : '2px',
          transition: 'left 0.2s ease'
        }} />
      </div>

      <span style={{
        color: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : '#1a1a1a',
        fontSize: '14px'
      }}>Dark</span>
    </div>
  );
};

export default ThemeToggle; 